import { useState } from "react";

function ImageCarousel({ images, productName }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fading, setFading] = useState(false);

  function goNext() {
    setFading(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
      setFading(false);
    }, 300);
  }

  function goPrev() {
    setFading(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
      setFading(false);
    }, 300);
  }

  if (!images || images.length === 0) {
    return <div className="carousel-placeholder"></div>;
  }

  return (
    <div className="carousel">
      <img
        src={images[currentIndex].filename}
        alt={productName}
        className={fading ? "carousel-img fading" : "carousel-img"}
      />
      {images.length > 1 && (
        <div className="carousel-controls">
          <button onClick={goPrev}>&#8592;</button>
          <button onClick={goNext}>&#8594;</button>
        </div>
      )}
    </div>
  );
}

export default ImageCarousel;
